import { useEffect, useState } from 'react'

export default ({ deps = [], fetchData = () => {}, params }) => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState()

  useEffect(() => {
    try {
      setLoading(true)
      fetchData(params).then(result => {
        setData(result)
        setTimeout(() => {
          setLoading(false)
        })
      })
    } catch (err) {
      console.error(err)
    }
  }, deps)

  const onUpdate = async (val) => {
    try {
      setLoading(true)
      const _data = await fetchData(val)
      setData(_data)
      setTimeout(() => {
        setLoading(false)
      })
      return _data
    } catch (err) {
      console.error(err)
    }
  }

  return {
    loading,
    data,
    onUpdate
  }
}
